import { render, staticRenderFns } from "./CreateSN.vue?vue&type=template&id=8256d046"
import script from "./CreateSN.vue?vue&type=script&lang=js"
export * from "./CreateSN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports